import React from "react";
import { dashboardColors, theme } from "../../../../themes/Theme";
import leftArrow from "../../../../assets/img/Left_Arrow.svg";
import rightArrow from "../../../../assets/img/Right_Arrow.svg";

export default function DotPagination({ page = 1 , pageCount = 1, onPageChange = () => {} }) {

  const handlePrevious = () => {
    if (page > 1) {
      onPageChange(page - 1);
    }
  };

  const handleNext = () => {
    if (page < pageCount) {
      onPageChange(page + 1);
    }
  };

  return (
    <div className="dashboard-dot-pagination">
      <button
        className={`report-pagination-arrow ${page === 1 ? 'disabled' : ''}`}
        disabled={page === 1}
        onClick={handlePrevious}
        aria-label="Previous"
      >
        <img src={leftArrow} alt="Previous" />
      </button>
      
      <div className="report-dots-container">
        {Array.from({ length: pageCount }, (_, idx) => (
          <button
            key={idx}
            className={`report-card-view-dot ${page === idx + 1 ? 'active' : ''}`}
            onClick={() => onPageChange(idx + 1)}
            aria-label={`Page ${idx + 1}`}
          />
        ))}
      </div>

      <button
        className={`report-pagination-arrow ${page === pageCount ? 'disabled' : ''}`}
        disabled={page === pageCount}
        onClick={handleNext}
        aria-label="Next"
      >
        <img src={rightArrow} alt="Next" />
      </button>

      <style jsx>{`
        .dashboard-dot-pagination {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 16px;
          padding: 32px 0 0 0;
        }

        .report-pagination-arrow {
          background: none;
          border: none;
          width: 20px;
          height: 20px;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: opacity 0.2s;
        }

        .report-pagination-arrow:hover:not(.disabled) {
          opacity: 0.7;
        }

        .report-pagination-arrow.disabled {
          opacity: 0.3;
          cursor: not-allowed;
        }

        .report-dots-container {
          display: flex;
          align-items: center;
          gap: 8px;
        }

        .report-card-view-dot {
          width: 8px;
          height: 8px;
          border-radius: 50%;
          border: none;
          background: #E5E5E5;
          transition: background 0.3s;
          cursor: pointer;
        }

        .report-card-view-dot:hover {
          background: #D1D5DB;
        }

        .report-card-view-dot.active {
          background: ${dashboardColors[theme].primary};
        }
      `}</style>
    </div>
  );
}
